<template>
  <div id="app">
    <headerCase></headerCase>
    <router-view />
    <footerCase></footerCase>
  </div>
</template>

<script>
import footerCase from "./components/footerCase.vue";
import headerCase from "./components/headerCase.vue";
export default {
  name: "App",
  components: {
    headerCase,
    footerCase,
  },
};
</script>

<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  font-family: Source Han Sans, Source Han Sans;
}
</style>
